export default __webpack_public_path__ + "static/media/Roboto-Black.27a22b09.ttf";